import React, {useCallback, useContext, useEffect} from 'react';
import BodyContentView from '../../views/bodyContentView';
import useKeyPress from '../../../hooks/useKeyPress';
import CommandsContext from '../../../context/commandsContext';
import Info from '.';
import {useMenu} from '../../../hooks/useMenu';

function SensorCase({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const {onUpdateCommands} = useContext(CommandsContext);
  const {onComponent} = useMenu();

  useEffect(() => {
    if (!leftPress) return;

    onLeft();
  }, [leftPress]);

  const onLeft = useCallback(() => {
    onComponent(<Info />);
  }, []);

  useEffect(() => {
    onUpdateCommands({onLeft});
  }, [onLeft]);

  return (
    <BodyContentView
      title="[017] Sensor Case Temp Fail"
      left="Back"
      right=""
      caption={
        <>
          <span>
            The values computed for the resistance of the meter and case RTDs are outside limits.
          </span>
          <p>1. Check the wiring between the sensor and the transmitter.</p>
          <p>
            a. Refer to the installation manuals and ensure that the wiring has been performed
            according to instructions. Obey all applicable safety messages.
          </p>
          <p> b. Verify that the wires are making good contact with the terminals.</p>
          <p> c. Perform RTD resistance checks and check for shorts to case.</p>
          <p> d. Check the continuity of all wires from the transmitter to the sensor.</p>
          <p>
            2. Check your process conditions against the values reported by the meter. Temperature
            should be between -200 °F and +400 °F.
          </p>
          <p>
            3. Verify that all of the characterization parameters match the data on the sensor tag.
          </p>
          <p>4. Contact Micro Motion.</p>
        </>
      }
    />
  );
}

export default SensorCase;
